<template>
	<div class="row">
		<div id="directions-via-toggle" class="col-1" @click="$emit('toggleViaPoint');" tabindex="0">
			<span class="material-icons" aria-hidden="true" v-if="showViaPoint">clear</span>
			<span class="material-icons" aria-hidden="true" v-else>add</span><br>
			<span>Via</span>
		</div>
    <div class="col-10">
      <div class="row">
  			<div class="directions-point-box col-12">
  				<span class="material-icons yellow-text" aria-hidden="true">place</span>
  				<input id="start-point-input" class="directions-point-input" placeholder="Søg efter startpunkt..." aria-label="Søg efter startpunkt" autocomplete="off" autofocus="off" @click="searchForAddress('start')">
  			</div>
        <div class="directions-point-box col-12">
          <span class="material-icons green-text" aria-hidden="true">place</span>
          <input id="end-point-input" class="directions-point-input" placeholder="Søg efter slutpunkt..." aria-label="Søg efter slutpunkt" autocomplete="off" autofocus="off" @click="searchForAddress('end')">
        </div>
        <div id="via-point-box" class="directions-point-box col-12" v-show="showViaPoint">
  				<span class="material-icons purple-text" aria-hidden="true">place</span>
  				<input id="via-point-input" class="directions-point-input" placeholder="Søg efter viapunkt..." aria-label="Søg efter viapunkt" autocomplete="off" autofocus="off" @click="searchForAddress('via')">
  			</div>
      </div>
    </div>
		<div id="directions-switcharoo" class="col-1" @click="$emit('switcharoo')" tabindex="0">
			<span class="material-icons" aria-hidden="true">swap_vert</span><br>
			<span>Ombyt</span>
		</div>
	</div>
</template>

<script>

export default {
  data() {
    return {

    }
  },
	props: {
		showViaPoint: {
			type: Boolean,
			required: true,
		}
	},
	methods: {
		//@click="$emit('toggleAddressSearch', 'start');"
		searchForAddress(direction) {
			this.$router.push('/directions/search/'+direction);
		}
	}
}
</script>

<style lang="scss" scoped>
  #directions-switcharoo, #directions-via-toggle {
    /*height: 70px;*/
    padding: 0px;
    text-align: center;
    text-shadow: 1px 1px #eee;
    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;
		cursor: pointer;
  }

  #directions-switcharoo span, #directions-via-toggle span {
    position: relative;
    top: 10px;
    font-size: 11px;
  }

  #directions-switcharoo .material-icons, #directions-via-toggle .material-icons {
    position: relative;
    top: 20px;
  }

  #directions-switcharoo .material-icons, .directions-point-box i, #directions-via-toggle .material-icons {
    font-size: 25px !important;
  }

	#directions-switcharoo {
		right: 5px;
	}

  .directions-point-box {
    height: 35px;
    padding: 0px;
  }

  .directions-point-box i {
    position: relative;
    top: 4px;
  }

  .directions-point-input {
    /*text-indent: 5px;
    width: 85%;
    outline: 0;
    border: 0;
    border-bottom: 1px solid #ddd;*/
    position: absolute;
    top: 4px;
    width: calc(100% - 35px);
    padding-left: 5px;
    border: 2px solid #d1d1d1;
    color: #565656;
    border-radius: 0px;
    -webkit-appearance: none;
    height: 26px;
  }

  .directions-point-input-more {
    padding: 0px;
  }

  .directions-point-input-more i {
    position: relative;
    top: 5px;
    font-size: 25px !important;
  }

</style>
